import { h } from 'preact';
import { useState, useRef } from 'preact/hooks';
import { Button } from 'react-bootstrap';
import Styles from './style.css';

const FileUploader = ({ acceptFormats, maxSize, multiple, onFileSelect }) => {
    const [dragging, setDragging] = useState(false);
    const browseRef = useRef(null);

    const handleDragEnter = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        handleFiles(event.dataTransfer.files);
    };

    const handleFileInput = (event) => {
        handleFiles(event.target.files);
    };

    const handleFiles = (files) => {
        const fileList = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (acceptFormats && !acceptFormats.includes(file.type)) {
                continue;
            }

            if (maxSize && file.size > maxSize) {
                continue;
            }

            fileList.push(file);
        }

        onFileSelect(fileList);
    };

    const handleBrowseClick = () => {
        browseRef.current.click();
    }

    return (
        <div
            className={`${Styles.fileUploader} ${dragging ? Styles.isDragging : ''}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <input ref={browseRef} type="file" onChange={handleFileInput} accept={acceptFormats} multiple={multiple} />
            <div className="file-uploader__text">
                <span>
                    <p>
                        Glissez-déposez le(s) document(s) <br /> ou{' '}
                    </p>{' '}
                    <button type="button" onClick={handleBrowseClick} className={`${Styles.btnBrowse}`}>Parcourir les fichiers</button>
                </span>
            </div>
        </div>
    );
};

export default FileUploader;
